import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { AssessmentProvider } from './context/AssessmentContext';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

import Landing from './pages/Landing';
import Assessment from './pages/Assessment';
import Results from './pages/Results';
import Admin from './pages/Admin';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <AssessmentProvider>
      <HashRouter>
        <div className="flex flex-col min-h-screen">
          <Header />
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/assessment" element={<Assessment />} />
              <Route path="/results/:id?" element={<Results />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </HashRouter>
    </AssessmentProvider>
  );
}

export default App;